<template>
  <h1 :class="$style.notFoundMsg">
    Page does not exist <a
      href="#"
      @click.prevent="backHandler"
    >go back instead</a>
  </h1>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();
    const backHandler = () => {
      router.go(-1);
    };
    return {
      backHandler,
    };
  },
};
</script>

<style lang="scss" module>
.notFoundMsg {
  margin-top: 4rem;
  text-align: center;
  font-size: 1.5rem;

  > a {
    color: rgba(30, 175, 62, 0.842)
  }
}
</style>
